import React from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { GlobalStyle } from './styles/global';
import { theme } from './styles/theme';
import { Layout } from './components/Layout/Layout';
import { AppRoutes } from './routes';
import { GlobalStyles } from './styles/GlobalStyles';
import { Footer } from './components/Footer/Footer';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <GlobalStyles />
          <Layout>
            <AppRoutes />
          </Layout>
          <Footer />
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
